<template>
  <div class="mark" v-show="isShowDialog" >
    <div class="dialog" :class="{'show-info': isShowDialog}">
      <p class="dialog-title" >
        <a  @click="expend"><iconx color='rgb(0,131,238)' type='daohangx'/></a>
        <a  @click="expend" style="color: #000"><span  class="title">{{isEnglish? dialogEngLishMap[0].english : dialogEngLishMap[0].chinese}}</span></a>
        <span @click.stop="close" class="close">
          <iconx type='guanbi1'/>
        </span>
      </p>
      
      <div class="content-img" v-if="detailData.img">
        <div class="img-item" @click="openVr" v-if="detailData.img_vr">
           <img :src="imgHost + detailData.img_vr" alt=""  class="vr-img">
           <img src="@/static/imgs/vrback.png" alt="" class="vr-back">
           <img src="@/static/imgs/720vr.png" alt="" class="bot-vr">
        </div>
        <div class="img-item" @click="showBigImg">
         <img :src="imgHost + detailData.img" alt=""   class="vr-img">
          <img src="@/static/imgs/spot.png" v-show="link_spot" alt="" class="bot-vr">

        </div>
        <div  class="content-msaage" style="font-size:14px" v-html="intro">
         
          
        </div>
      </div>
      <p style="font-size: 16px; padding: 4px 16px">{{title}}</p>
      <p v-html="info" style="padding: 16px;font-size: 16px" class="container-info"></p>
      <img :src="imgHost + detailData.img" alt="" class="fixed-img" :class="{'preview-img': isShowImg}" v-if="isShowImg" @click="showBigImg">
    </div>
    
  </div>
</template>
<script>
import eventBus from '@/utils/eventBus'
import {imgHost} from '@/api/api'
import iconx from './iconx'
import {dialogEngLishMap} from '@/static/const.js'
export default {
  created () {
    // this.geolocation = new qq.maps.Geolocation(
    //   'BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM',
    //   'audioApp'
    // ) // 获取当前位置信息
    this.initEventBus()
    this.isWeixi()
    
  },
  props: {
   spointx: {
     type: Number,
     default: null
   },
   spointy: {
     type: Number,
     default: null
   },
   isEnglish: {
     type: Boolean,
     default: false
   }
  },
  data () {
    return {
      top: '-100%',
      isShowDialog: false,
      timer: null,
      sword: '', // 起点名称
      eword: '', // 终点名称
      epointx: '', // 终点经度
      epointy: '', // 终点纬度
      transport: 3, // '指定使用步行方案'
      back: 1, // 展示返回按钮
      title: '',
      isHelp: false,// 是否是帮助中心
      info: '',
      mylat: null,
      mylng: null,
      options: { timeout: 1000 },
      geolocation: null,
      detailData: {},
      imgHost,
      isShowImg: false,
      dialogEngLishMap,
      key: 'BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM', // 开发者的key值
      link_spot:"",
      intro:""
    }
  },
  computed: {
    href: function () {
      let herf = `https://apis.map.qq.com/tools/routeplan/spointx=${this.spointx}&spointy=${this.spointy}&epointx=${this.epointx}&epointy=${this.epointy}&eword=${this.eword}?referer=myapp&key=${localStorage.getItem("tx_map_key")?localStorage.getItem("tx_map_key"):"BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM"}`
      return herf
    }
  },
  components: {
    iconx
  },
  
  methods: {
    expend(){
      // alert(123456,window.__wxjs_environment)
      // alert(window.__wxjs_environment)
      //  alert(Number(this.epointx))
      //  alert(Number(this.epointy))
       var ua = navigator.userAgent.toLowerCase();
       

         

      if(ua.match(/MicroMessenger/i) != "micromessenger"){
        window.location.href=this.href

      }else{
      // alert(123456)

      //  alert(this.$wx.openLocation)
      //  alert(this.epointx)
      //  alert(this.epointy)

          this.$wx.openLocation({
            latitude:parseFloat(this.epointx),
            longitude:parseFloat(this.epointy),
            scale: 18,
            success:function(res){
              // alert(JSON.stringify(res))
            },
            fail:function(err){
              // alert(JSON.stringify(err))
            }
          })

      }
      // console.log(this.$wx)
      
      //  console.log(window.__wxjs_environment === 'miniprogram')
      

      
    },
     isWeixi(){
       
      //  console.log(window.__wxjs_environment === 'miniprogram')
      
    },

    close () {
      this.isShowDialog = false
      this.detailData = {}
      this.isShowImg = false
      // this.top = '-100%'
      eventBus.emit('changeShowInfo')
    },


    initEventBus() {
      eventBus.on('showInfo', message => {
        console.log(message)
      this.isShowDialog = true
      this.eword = message.info.address
      this.epointx = message.epointx
      this.epointy = message.epointy
      this.detailData = message.info
      this.isHelp = false
      this.title = this.isEnglish ? message.info.name_eng : message.info.name
      this.info = this.isEnglish ?  message.info.content_eng : message.info.content
      this.link_spot=message.info.link_spot
      this.intro=message.info.intro ?message.info.intro:""
    })
    },
    // 查看vr
    openVr(){
      window.open(this.detailData.link_vr) 
    },
    showBigImg() {
      // console.info(this.link_spot)
      if(this.link_spot){
        window.open(this.link_spot)
      }else{
       this.isShowImg = !this.isShowImg

      }
       
    },
    setInfo (data) {
      this.isShowDialog = true
      this.title = data.name
      this.isHelp = true
      this.info = this.isEnglish ? data.content_eng : data.content
      
      this.eword = data.address
      this.epointx = data.coordinate.split(',')[1]
      this.epointy = data.coordinate.split(',')[0]
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="scss" scoped>
.mark {
  width: 100%;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000000000;
}
.show-info {
  top: 50% !important;
  transition: top 0.65s ease-in-out !important;
    .fixed-img {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 100px;
    height: auto;
    z-index: 100000000000;
    transform: translateX(-50%) translateY(-50%);
  }
  .preview-img {
    width: 300px;
    transition: width 0.65s ease-in-out !important;
  }
}
.dialog {
  width: 92%;
  height: 83%;
  overflow-y: auto;
  position: fixed;
  top: -100%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000000;
  opacity: 1;
  background-color: #ffffff;
  border-radius: 9px;
  .dialog-title {
    width: 100%;
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    padding: 0 18px;
    box-sizing: border-box;
    background-color: #F7F7F7;
    .title {
      max-width: 240px;
      overflow: hidden;
      display: inline-block;
    }
  }
  .content-img {
    width:  100%;
   overflow: hidden;
   padding: 16px 16px 0 16px;
   box-sizing: border-box;
   display: flex;

    .img-item {
      flex: 1;
     
      width: 140px;
      height: 140px;
      border-radius: 8px;
      margin-right: 16px;
      position: relative;
      .vr-img{
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
      .vr-back {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 50px;
        height: 50px;
      }
      .bot-vr {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 50%;
      }
    }
  }
  .isShowImg {
    width: 70% !important;
    height: auto !important;
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialogInfo.vue